<template lang="pug">
  .user-notifications
    .count(v-if="newItemsCount > 0" @click="opened = !opened") {{ newItemsCount > 99 ? '99+' : newItemsCount }}
    Icon.icon(name="bell2" pointer @click.native="opened = !opened")
    .list(v-if="opened")
      .item(v-for="item in itemsToShow" :class="{ new: !item.isViewed }")
        Icon.hide(name="close3" pointer @click.native.stop="$store.dispatch('notification/hide', item)")
        NotificationComponentSelector.type(:item="item" type="icon")
        NotificationComponentSelector.title(:item="item" type="title" @click.native="clickNotification")
        .user(v-if="item.initiator")
          UserAvatar.avatar(:user="item.initiator" :size="30")
          .username {{ item.initiator.name }} {{ item.initiator.surname }}
          .date {{ formatDate(item.createdAt) }}
        .date(v-else) {{ formatDate(item.createdAt) }}
      .btn-wrap
        Btn.btn(:to="{ name: 'notifications' }") Все уведомления

</template>

<script>
import utils from '@/utils/common';

import UserAvatar from '@/components/UserAvatar.vue';
import NotificationComponentSelector from '@/components/notification/NotificationComponentSelector.vue';

export default {
  name: 'HeaderUserNotifications',
  components: { UserAvatar, NotificationComponentSelector },
  data() {
    return {
      notViewedItems: new Set(),
      opened: false,
    };
  },
  computed: {
    items() { return this.$store.state.notification.items; },
    newItemsCount() { return this.items.filter((n) => !n.isViewed).length; },
    notHiddenItems() { return this.items.filter((n) => !n.isHidden); },
    topItems() { return this.notHiddenItems.slice(0, 5); },
    itemsToShow() {
      return this.topItems.map((i) => ({
        ...i,
        isViewed: this.notViewedItems.has(i.id) ? false : i.isViewed,
      }));
    },
  },
  watch: {
    opened(val) {
      if (val) {
        this.topItems
          .filter((i) => !i.isViewed)
          .forEach((i) => {
            this.notViewedItems.add(i.id);
            this.$store.dispatch('notification/view', i);
          });
      } else {
        this.notViewedItems = new Set();
      }
    },
  },
  created() {
    this.$store.dispatch('notification/fetch');
  },
  methods: {
    formatDate(date) {
      return date ? utils.convertDateToString(new Date(date), 'short', true) : '';
    },
    clickNotification(e) {
      if (e.target.tagName !== 'A') return;
      if (e.ctrlKey) return;

      this.opened = false;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.opened = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },
};
</script>

<style scoped lang="scss">
  .user-notifications {
    width: 40px;
    height: 32px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .count {
      padding: 2px 6px;
      background: #4DD861;
      border-radius: 12px;
      font-size: 12px;
      line-height: 1;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .list {
      width: 350px;
      max-width: 100vw;
      background: #fff;
      position: absolute;
      top: 52px;
      right: -99px;
      z-index: 999;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      color: #000;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 1px;
    }

    .item {
      position: relative;
      padding: 30px 20px 17px;
      cursor: auto;
      display: grid;
      grid-template-columns: 20px 1fr;
      column-gap: 12px;

      .title::v-deep {
        font-weight: bold;
        font-size: 13px;
        line-height: 18px;
        color: var(--color-dark-gray);
        a {
          font-weight: normal;
          color: var(--color-accent) !important;
        }
      }

      &:after {
        content: '';
        display: block;
        margin: 0 20px;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: var(--color-purple);
      }

      &.new {
        background: #F5F7F9;

        &:after {
          display: none;
        }
      }
    }

    .hide {
      position: absolute;
      top: 16px;
      right: 19px;
    }

    .icon {
      grid-row: 1 / 2 span;
    }

    .user {
      display: grid;
      grid-template-columns: max-content 1fr;
      column-gap: 12px;
      row-gap: 1px;
      align-items: center;
      margin-top: 12px;

      .avatar {
        grid-row: 1 / 2 span;
      }

      .date {
        margin-top: 0;
      }
    }

    .username {
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.01em;
      color: var(--color-dark-gray);
    }

    .date {
      color: var(--color-middle-gray);
      font-weight: normal;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.01em;
      margin-top: 3px;
    }

    .btn-wrap {
      padding: 22px 20px;
      width: 100%;
      box-sizing: border-box;
    }

    .btn {
      width: 100%;
    }
  }
</style>
